module.exports = __webpack_public_path__ + "static/media/04_Top-Tips-Animated.615ba486.gif";